var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBirthday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cake_FILL1_wght300_GRAD0_opsz48 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.36537 21.5C4.12019 21.5 3.91467 21.4137 3.7488 21.2413C3.58293 21.0688 3.5 20.8602 3.5 20.6153V15.4577C3.5 15.066 3.64248 14.7277 3.92743 14.4428C4.21236 14.1578 4.55066 14.0154 4.94232 14.0154H19.0576C19.4493 14.0154 19.7876 14.1578 20.0725 14.4428C20.3575 14.7277 20.5 15.066 20.5 15.4577V20.6153C20.5 20.8602 20.4137 21.0688 20.2413 21.2413C20.0688 21.4137 19.8602 21.5 19.6153 21.5H4.36537ZM5.62692 12.8808V9.46535C5.62692 9.06728 5.76939 8.72738 6.05432 8.44565C6.33926 8.16392 6.67756 8.02305 7.06922 8.02305H11.4327V6.4423C11.1186 6.22818 10.8708 5.99296 10.6894 5.73663C10.508 5.48029 10.4173 5.17413 10.4173 4.81813C10.4173 4.59963 10.4583 4.39054 10.5404 4.19087C10.6224 3.99121 10.7372 3.81797 10.8846 3.67115L12 2.5L13.1142 3.67002C13.2624 3.81821 13.3817 3.99198 13.4721 4.19135C13.5625 4.3907 13.6077 4.59963 13.6077 4.81813C13.6077 5.17413 13.5128 5.48029 13.323 5.73663C13.1333 5.99296 12.8814 6.22818 12.5673 6.4423V8.02305H16.9307C17.3224 8.02305 17.6607 8.16392 17.9456 8.44565C18.2306 8.72738 18.373 9.06728 18.373 9.46535V12.8808H5.62692Z",
    fill: "#2B2B2B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthday);
export default __webpack_public_path__ + "static/media/birthday.bc2ef81add9d0510345d2ab7d37cbc67.svg";
export { ForwardRef as ReactComponent };